export default __webpack_public_path__ + "static/media/Emotional04.cb6e516c.png";